import { useState } from "react";
import { api, apiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { CheckCircle2, FileUp, Loader2 } from "lucide-react";

const DOCS = { statuto: "Statuto dell'ente", bilanci: "Ultimi 3 bilanci con relazione degli amministratori", rendiconto_ets: "Ultimo rendiconto (ETS)" };
export const docDoRichiesti = (tipoEnte) => ["statuto", tipoEnte === "ets" ? "rendiconto_ets" : "bilanci"];

const Riga = ({ codice, tipo, caricato, onCaricato }) => {
  const [busy, setBusy] = useState(false);
  const carica = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("codice", codice); fd.append("product", "d_o"); fd.append("tipo", tipo); fd.append("file", file);
      const { data } = await api.post("/public/accordi/allegati", fd);
      onCaricato(data);
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <label className="flex cursor-pointer items-center justify-between gap-3 rounded-lg border bg-white px-3 py-2.5 text-sm hover:bg-sage/30" data-testid={`do-doc-${tipo}`}>
      <span className="text-forest">{DOCS[tipo]}{caricato && <span className="block text-xs text-muted-foreground" data-testid={`do-doc-${tipo}-nome`}>{caricato.filename}</span>}</span>
      {busy ? <Loader2 className="h-4 w-4 animate-spin text-forest" /> : caricato ? <CheckCircle2 className="h-5 w-5 text-emerald-600" /> : <FileUp className="h-4 w-4 text-terracotta" />}
      <input type="file" accept=".pdf,.jpg,.jpeg,.png,.webp" className="hidden" data-testid={`do-doc-${tipo}-input`} onChange={(e) => carica(e.target.files?.[0])} />
    </label>
  );
};

// Statuto e bilanci (o rendiconto per gli ETS) obbligatori per inviare la pratica D&O.
export const DocumentiDo = ({ codice, tipoEnte, value, onChange }) => {
  const [nomi, setNomi] = useState({});
  return (
    <div className="space-y-2 rounded-xl border border-forest/15 bg-sage/30 p-4" data-testid="do-documenti">
      <div className="font-heading font-semibold text-forest">Documenti per la Direzione</div>
      <p className="text-xs text-muted-foreground">Obbligatori per salvare e inviare la pratica. PDF o foto, max 20 MB.</p>
      {docDoRichiesti(tipoEnte).map((t) => (
        <Riga key={t} codice={codice} tipo={t} caricato={value[t] && nomi[t]}
          onCaricato={(d) => { setNomi((n) => ({ ...n, [t]: d })); onChange(t, d.id); }} />
      ))}
    </div>
  );
};
